/* global Vue, VueI18n, CLD_URL, CLD_TRANSFORM, useOffers */

import { formatDateForMaistra } from 'scripts/utils-common'

const FocusedCard = {
  name: 'FocusedCard',
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  template: `
    <a class="focused-card" :class="'focused-card--' + result.type" :href="result.url">
      <div class="focused-card__image">
        <img :src="transformCldUrl(result.image, 200, 200)" />
      </div>
      <div class="focused-card__content">
        <div class="focused-card__teaser" v-if="offer">{{ offer.teaser }}</div>
        <div>
          <div class="h3">
            {{ result.title }}
              <span v-if="result.type === 'property' && result.stars" class="stars" :class="'theme--' + result.brand[0]">
                <i v-for="n in result.stars" class="icon-star"></i>
              </span>
          </div>
          <div class="focused-card__destination" v-if="result.type !== 'destination'">{{ result.destination.join(' | ') }}</div>
        </div>
        <div class="focused-card__description" v-if="description">{{ description }}</div>
      </div>
    </a>
  `,
  setup (props) {
    const { result } = Vue.toRefs(props)
    const { t } = VueI18n.useI18n()

    function transformCldUrl (url, width, height) {
      const widthParam = width ? `w_${width},` : ''
      const heightParam = height ? `h_${height},` : ''
      return url.replace(CLD_URL, `${CLD_URL}${widthParam}${heightParam}${CLD_TRANSFORM}/`)
    }

    const offer = Vue.ref(null)

    Vue.watch(result, async () => {
      offer.value = null
      if (result.value.type === 'offer') {
        const offers = await useOffers()
        offer.value = offers.find(offer => offer.link === `${result.value.url}/`)
      }
    }, { immediate: true })

    const description = Vue.computed(() => {
      if (result.value.type === 'property') {
        return result.value.teaser
      }

      if (offer.value) {
        return offer.value.periodsText
          ? `${t('offers.period')} ${offer.value.periodsText}`
          : `${formatDateForMaistra(new Date(offer.value.startDate))} - ${formatDateForMaistra(new Date(offer.value.endDate))}`
      }

      return null
    })

    return {
      transformCldUrl,
      offer,
      description,
    }
  },
}

export default FocusedCard
